import { retrieveToken } from '../storage';
import {
  wrapFetch,
  wrapFetchWithDetailedErrors,
  apiFetch,
  fetchWithRetry,
  OPERAZIONE_NON_CONSENTITA,
  apiError,
  RICHIESTA_NON_VALIDA,
} from './api';
const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const logIn = (username, password) => {
  const PATH = '/api/login/backoffice';
  const URL = BASE_URL + PATH;
  const requestBody = {
    username: username,
    password: password,
  };
  return wrapFetchWithDetailedErrors(
    fetchWithRetry(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: RICHIESTA_NON_VALIDA,
      401: 'Username e/o password errata.',
      403: 'Username e/o password errata.',
      404: 'Username e/o password errata.',
    }),
  );
};

export const getAccountData = () => {
  const token = retrieveToken();
  const PATH = '/api/account';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      401: OPERAZIONE_NON_CONSENTITA,
      404: OPERAZIONE_NON_CONSENTITA,
    }),
  );
};

export const resetPassword = (userEmail, psw) => {
  const token = retrieveToken();
  const PATH = '/api/account/reset_password';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  const requestBody = {
    email: userEmail,
    password: psw,
  };
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: 'Ripristino non riuscito: nuova password non valida.',
      404: 'Nessun utente trovato con indirizzo email ' + userEmail,
    }),
  );
};

export const exchangeMicrosoftToken = (msToken) => {
  const PATH = '/api/auth/oauth';
  const URL = BASE_URL + PATH;
  const requestBody = {
    pkceToken: msToken,
  };
  return wrapFetchWithDetailedErrors(
    fetchWithRetry(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: RICHIESTA_NON_VALIDA,
      401: 'Autenticazione Microsoft fallita.',
      403: 'Autenticazione Microsoft fallita.',
      404: 'Autenticazione Microsoft fallita.',
    }),
  );
};

export const setUserActivation = (userId, activate) => {
  const token = retrieveToken();
  const PATH = `/api/utenti/${userId}/${activate ? 'attiva' : 'disattiva'}`;
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetchWithDetailedErrors(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
